<template>
  <div class="modal-wrapper" v-if="showModal">
    <div class="modal">
      <img style="margin-top: 20px; margin-bottom: -15px" src="../../../assets/images/statusPagePasswordLogo.svg" alt="">
      <h3 class="privateStatusPageHeader">{{ headerText }}</h3>
      <h4 class="privateStatusPageHeader2">Enter a shared password to get access to this private status page.</h4>
      <form @submit.prevent="handleSubmit()">
        <div class="d-flex justify-content-center mt-3 mx-5">
          <base-textbox :placeholder="passwordPlaceholder" type="password"
                        v-model="password" class="passwordForm"/>
        </div>
        <div class="submit-button-wrapper">
          <base-button class="signInButton" type="submit" :disabled="!valid" :loading="saving">
            {{ submitButtonText }}
          </base-button>
        </div>
        <base-alert v-if="error" type="error">Something went wrong.</base-alert>
      </form>
    </div>
  </div>
</template>

<script>
import statusPagesApi from '@/api/statusPagesApi'

export default {
  name: 'statusPagePassword',
  props: {
    statusPagePasswordError: {
      type: Boolean
    },
    slug: {
      type: String,
      required: false
    },
    showModal: {
      required: true,
      type: Boolean
    }
  },

  data () {
    return {
      password: '',
      saving: false,
      error: null,
      statusPageLanguage: {}
    }
  },

  created () {
    this.loadStatusPageLanguage()
  },

  computed: {
    valid () {
      return this.password.length > 0
    },

    headerText () {
      return this.statusPageLanguage.text_password_header ?? 'Private Status Page'
    },

    passwordPlaceholder () {
      return this.statusPageLanguage.text_password_input_placeholder ?? 'Enter password'
    },

    submitButtonText () {
      return this.statusPageLanguage.text_password_button_submit ?? 'Sign In'
    }
  },

  methods: {
    handleSubmit () {
      this.$emit('loadPage', this.password)
      this.saving = true
    },

    async loadStatusPageLanguage () {
      const response = await statusPagesApi.getPasswordTranslation(this.slug ?? window.location.hostname)
      if (response?.json_data) {
        this.statusPageLanguage = JSON.parse(response.json_data)
      }
    }
  },

  watch: {
    statusPagePasswordError () {
      if (this.saving === true) {
        this.error = true
        this.saving = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  border-radius: 12px;
  border: 1px solid rgba(25, 34, 29, 0.06);
  background: #FFF;
  box-shadow: 0px 8px 24px 0px rgba(25, 34, 29, 0.08);
  width: 580px;
  height: 400px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.submit-button-wrapper {
  display: flex;
  justify-content: center;
}
.privateStatusPageHeader {
  max-width: 90%;
  margin: 0 auto;
  text-align: center;
  color: #19221D;
  font-family: Inter;
  font-size: 24px;
  font-weight: 600;
}

.privateStatusPageHeader2 {
  max-width: 75%;
  margin: 0 auto;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
}

.signInButton {
  width: 130px;
  height: 50px;
  flex-shrink: 0;
  border-radius: 4px;
  background: var(--Green-1, #219653);
}

.passwordForm {
  border-radius: 4px;
  height: 50px;
  width: 400px;
}
</style>
